import type { ReactNode } from 'react';
import { Row } from 'ui';

type P = {
  children: ReactNode;
};

const EventInviteesListRow = ({ children }: P) => (
  <Row align="middle" className="event-invitees-list-row">
    {children}
  </Row>
);

export default EventInviteesListRow;
